/** @jsxImportSource @emotion/react */
import React from 'react'

interface DemoLeaguesIconProps extends React.HTMLAttributes<HTMLSpanElement> {
  size?: number
  color?: string
}

const DemoLeaguesIcon: React.FC<DemoLeaguesIconProps> = ({
  size,
  color,
  className,
  style,
  ...rest
}) => {
  return (
    <span className={`anticon ${className || ''}`} style={style} {...rest}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size ? `${size}px` : '1em'}
        height={size ? `${size}px` : '1em'}
        viewBox='0 0 24 24'
        fill='none'
      >
        <path
          d='M13 11.33L18 18H6L11 11.33V6H13M15.96 4H8.04C7.62 4 7.39 4.48 7.65 4.81L9 6.5V10.67L3.2 18.4C2.71 19.06 3.18 20 4 20H20C20.82 20 21.29 19.06 20.8 18.4L15 10.67V6.5L16.35 4.81C16.61 4.48 16.38 4 15.96 4Z'
          fill={color || 'currentColor'}
        />
      </svg>
    </span>
  )
}

export default DemoLeaguesIcon
